import { gql } from '@apollo/client'

const EDIT_PATIENT_TAG = gql`
  mutation EDIT_PATIENT_TAG(
    $patientTag: ID!
    $name: String!
    $order: Int
    $color: String!
    $icon: String
    $nextTags: [ID]
    $forQrCode: Boolean
    $forWhatsApp: Boolean
  ) {
    editPatientTag(
      patientTag: $patientTag
      name: $name
      order: $order
      color: $color
      icon: $icon
      nextTags: $nextTags
      forQrCode: $forQrCode
      forWhatsApp: $forWhatsApp
    ) {
      id
      name
      order
      color
      icon
      hasNextTags
      forQrCode
      forWhatsApp
      createdAt
      updatedAt
      createdBy {
        id
        name
      }
      updatedBy {
        id
        name
      }
      nextTags {
        id
        name
        color
      }
    }
  }
`

export default EDIT_PATIENT_TAG
